

const iconStyle = { position: 'absolute', right: 0, top: "50%", transform: "translateY(-50%)" };
const Down = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" style={iconStyle} width="13.671" height="8.382" viewBox="0 0 13.671 8.382">
            <g id="Drop_Down" dataname="Drop Down" transform="translate(0.705 0.705)">
                <path id="Path" d="M2,5l6.131,7.177L14.261,5" transform="translate(-2 -5)" fill="none" stroke="#14a4c2" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" />
            </g>
        </svg>
    )
};

export default Down